export const ScrollAnimator = (function () {
	'use strict';

	function init() {
		/*
			data-scroll-animator="effect|offset|start|end"

			effect: one of the animation functions (aniFuncs) listed below
			offset: the position within the element to use as the trigger point. 0 is top, 1 is bottom
			start: where the start trigger point is relative to the window viewport. 0 is top of window, 1 is bottom
			end: where the end trigger point is relative to the window viewport. 0 is top of window, 1 is bottom

			example: data-scroll-animator="fadeIn|0.5|1|0.75"
				Apply the fadeIn function to this element, using the vertical middle point of the element as the trigger.
				The effect will start when the trigger passes the bottom of the page, and will end when it passes
				three-quarters down the window (full fade-in will happen within the bottom 1/4 of window).

		*/
		const ease = window.EasingFunctions

		const items = []
		const aniFuncs = {
			bannerHide: (el, progress) => {
				progress = ease.easeInQuad(progress)
				el.style.transform = `translateY(${-40 * progress}%)`
			},
			fadeIn: (el, progress) => {
				el.style.opacity = progress
			},
			fadeOut: (el, progress) => {
				el.style.opacity = ease.easeInQuad(1 - progress)
			},
			slideY30: (el, progress) => {
				progress = progress - 0.5
				el.style.transform = `translateY(${30 * progress}%)`
			},
			slideY100: (el, progress) => {
				progress = progress - 0.5
				el.style.transform = `translateY(${100 * progress}%)`
			},
			documents: (el, progress) => {
				progress = ease.easeInQuad(1 - progress)
				el.style.transform = `translateX(${-30 * progress}%)`
			},
			imgInLeft: (el, progress) => {
				progress = ease.easeInQuad(1 - progress)
				el.style.transform = `translateX(${-20 * progress}%)`
			},
			slider1: (el, progress) => {
				progress = ease.easeInQuad(1 - progress)
				el.style.transform = `translateY(${-30 * progress}%)`
			},
			slider2: (el, progress) => {
				progress = ease.easeInQuad(1 - progress)
				el.style.transform = `translateY(${30 * progress}%)`
			}
		}
		const onScroll = () => {
			const scrollY = window.scrollY
			items.forEach((item) => {
				let progress = 1
				if (item.start > scrollY) {
					progress = 0
				} else if (item.end < scrollY) {
					progress = 1
				} else {
					const range = item.end - item.start
					progress = (scrollY - item.start) / range
				}
				aniFuncs[item.func](item.el, progress)
			})

		}
		const updatePosition = (item) => {
			const transform = item.el.style.transform
			item.el.style.transform = 'none'
			const rect = item.el.getBoundingClientRect()
			item.el.style.transform = transform
			const elOffset = rect.height * item.offset
			const elTop = rect.top + window.scrollY
			const winHeight = window.innerHeight
			item.start = elTop + elOffset - (winHeight * item.pageStart)
			item.end = elTop + elOffset - (winHeight * item.pageEnd)
		}
		const onResize = () => {
			items.forEach(updatePosition)
			onScroll()
		}
		const addItem = (el) => {
			const existing = items.find(item => item.el === el)
			if (existing) {
				return
			}
			const props = el.getAttribute('data-scroll-animator').split(',')
			const item = {
				el,
				func: props[0].trim(),
				offset: parseFloat(props[1]),
				pageStart: parseFloat(props[2]),
				pageEnd: parseFloat(props[3]),
				start: 0,
				end: 0,
				progress: 0
			}
			if (aniFuncs[item.func]) {
				items.push(item)
			} else {
				console.log('unknown animate function', item)
			}
		}
		const updateItemsList = () => {
			const aniElements = document.querySelectorAll('[data-scroll-animator]')
			aniElements.forEach(addItem)
		}
		window.addEventListener('px-content-added', updateItemsList, { capture: true, passive: true })
		window.addEventListener('px-debounced-resize', onResize, { capture: true, passive: true })
		window.addEventListener('scroll', onScroll, { capture: true, passive: true })
		updateItemsList()
	}

	return {
		init: init,
	};
})();
